import { gql } from 'graphql-request'

export const EXPORT_SALES_REPORTS = gql`
  query ExportSalesReports($startDate: DateTime, $endDate: DateTime) {
    exportSalesReports(startDate: $startDate, endDate: $endDate)
  }
`
